import React, { useState } from 'react';
import './AjudaPage.css';

const SECOES = [
  {
    id: 'dashboard',
    icon: '⊞',
    titulo: 'Dashboard',
    cor: 'var(--accent)',
    topicos: [
      {
        pergunta: 'O que é o Dashboard?',
        resposta: 'O Dashboard é a tela principal do Fincasa. Nele você visualiza e controla todos os seus gastos mensais organizados por categoria, com totais automáticos e comparativo com o limite mensal definido por você.'
      },
      {
        pergunta: 'Como selecionar o mês e o ano?',
        resposta: 'Use as abas de meses no topo (Jan, Fev, Mar...) para navegar entre os meses. O seletor de ano fica ao lado do botão Ocultar/Mostrar valores — use-o para acessar o histórico de anos anteriores ou planejar anos futuros.'
      },
      {
        pergunta: 'Como adicionar uma nova conta?',
        resposta: 'Clique no botão "+ Nova Conta" no canto superior direito. Preencha o nome da conta, o tipo (Cartão, Fixo, Outro ou tipo personalizado), o dia de fechamento (para cartões) e o dia de vencimento. Clique em "Criar Conta" para salvar.'
      },
      {
        pergunta: 'Como lançar um valor na tabela?',
        resposta: 'Clique diretamente em qualquer célula da tabela no mês desejado. Um campo de edição aparecerá — digite o valor e pressione Enter ou clique fora para salvar. O total é atualizado automaticamente.'
      },
      {
        pergunta: 'O que é o Limite Mensal?',
        resposta: 'O Limite Mensal é um valor de referência que você define para controlar seus gastos. Clique no ícone de lápis (✎) no card "Limite Mensal" nos cards de resumo, ou edite diretamente na linha "LIMITE MENSAL" na tabela. A linha "DIFERENÇA DO LIMITE" mostra automaticamente se você está dentro (verde) ou acima (vermelho) do limite.'
      },
      {
        pergunta: 'O que significa a Diferença do Limite?',
        resposta: 'É o resultado do Limite Mensal menos o Total Gasto. Valor em verde significa que você gastou menos que o limite — sobrou dinheiro. Valor em vermelho significa que você ultrapassou o limite definido.'
      },
      {
        pergunta: 'Como ocultar os valores financeiros?',
        resposta: 'Clique no botão "◎ Ocultar" ao lado do seletor de ano. Todos os valores serão substituídos por "••••••". Clique em "◉ Mostrar" para exibir novamente. Útil quando estiver em locais públicos ou compartilhando a tela.'
      },
      {
        pergunta: 'Como editar ou excluir uma conta?',
        resposta: 'Na coluna "Ações" à direita da tabela, clique no ícone ✎ para editar ou ✕ para excluir. Ao excluir, todos os lançamentos daquela conta também são removidos.'
      },
      {
        pergunta: 'O que são os filtros Todos / Cartão / Fixo / Outro?',
        resposta: 'São filtros que exibem apenas as contas de um determinado tipo. "Todos" mostra tudo. Os demais filtros exibem somente as contas daquela categoria. Se você criou tipos personalizados, eles também aparecerão aqui.'
      },
    ]
  },
  {
    id: 'tipos',
    icon: '📂',
    titulo: 'Tipos de Conta',
    cor: 'var(--accent)',
    topicos: [
      {
        pergunta: 'O que são Tipos de Conta?',
        resposta: 'Além dos tipos padrão (Cartão, Fixo e Outro), você pode criar tipos personalizados para organizar melhor suas contas. Exemplos: "Casa", "Saúde", "Educação", "Lazer".'
      },
      {
        pergunta: 'Como criar um novo tipo?',
        resposta: 'Acesse "Tipos de Conta" no menu lateral. Clique em "+ Novo Tipo", escolha um ícone emoji, dê um nome e salve. O novo tipo aparecerá automaticamente no filtro da tabela assim que você cadastrar uma conta com ele.'
      },
      {
        pergunta: 'Por que meu tipo não aparece na tabela?',
        resposta: 'O tipo só aparece no filtro da tabela quando há pelo menos uma conta cadastrada com aquele tipo. Crie uma conta usando o tipo personalizado e ele aparecerá automaticamente.'
      },
      {
        pergunta: 'Posso editar ou excluir um tipo?',
        resposta: 'Sim! Na página de Tipos de Conta, cada tipo tem botões de editar (✎) e excluir (✕). Atenção: ao excluir um tipo, as contas que usavam esse tipo não são excluídas, mas ficarão sem tipo definido.'
      },
    ]
  },
  {
    id: 'emprestimos',
    icon: '🏦',
    titulo: 'Empréstimos',
    cor: '#4f8ef7',
    topicos: [
      {
        pergunta: 'O que é o módulo de Empréstimos?',
        resposta: 'O módulo de Empréstimos permite controlar dívidas e financiamentos separadamente dos gastos mensais. Você registra o empréstimo uma vez e vai lançando os pagamentos mês a mês, com o saldo devedor atualizado automaticamente.'
      },
      {
        pergunta: 'Qual a diferença entre Parcelado e Livre + IPCA?',
        resposta: 'Parcelado: usado para financiamentos com parcelas fixas e prazo definido, como financiamento de carro ou empréstimo bancário com parcelas iguais. O sistema calcula automaticamente o valor da parcela com base no total e número de parcelas. Livre + IPCA: usado para empréstimos informais onde o pagamento é livre (qualquer valor, a qualquer momento) e o saldo é corrigido anualmente pelo IPCA. Ideal para empréstimos entre pessoas físicas.'
      },
      {
        pergunta: 'Como registrar um pagamento?',
        resposta: 'Clique no empréstimo na lista à esquerda para selecioná-lo. No grid de meses à direita, clique no mês em que o pagamento foi feito. Informe o valor pago — o saldo devedor é calculado automaticamente. Confirme clicando no ✓ verde.'
      },
      {
        pergunta: 'Como funciona o cálculo do saldo devedor?',
        resposta: 'O saldo devedor é calculado automaticamente: Saldo Anterior − Valor Pago = Novo Saldo. O sistema usa sempre o saldo do mês imediatamente anterior como base. Você pode ajustar o saldo manualmente caso o credor informe um valor diferente.'
      },
      {
        pergunta: 'Como funciona a correção pelo IPCA?',
        resposta: 'Exclusivo do tipo Livre + IPCA. Em janeiro de cada ano, ao registrar o pagamento, aparece um campo extra para informar o % do IPCA do ano anterior. O sistema calcula a correção (Saldo após pagamento × IPCA%) e soma ao saldo devedor automaticamente. Exemplo: saldo R$ 70.000, IPCA 4,5% → correção de R$ 3.150 → novo saldo R$ 73.150.'
      },
      {
        pergunta: 'A barra de progresso está errada, como corrigir?',
        resposta: 'A barra de progresso mostra quanto do valor original já foi pago. Se os registros anteriores estiverem com saldo errado, exclua-os (clique no × no canto do mês) e relance na ordem correta — do mês mais antigo para o mais recente.'
      },
      {
        pergunta: 'Posso ter mais de um empréstimo cadastrado?',
        resposta: 'Sim! Você pode cadastrar quantos empréstimos quiser — parcelados, livres ou uma mistura dos dois. Cada um aparece na lista à esquerda. Clique em um para ver e registrar seus pagamentos.'
      },
    ]
  },
  {
    id: 'compartilhamento',
    icon: '👥',
    titulo: 'Compartilhamento',
    cor: 'var(--warn)',
    topicos: [
      {
        pergunta: 'Como funciona o compartilhamento de contas?',
        resposta: 'Um usuário pode compartilhar suas contas e lançamentos com outro usuário do mesmo grupo. Ambos passam a ver e editar as mesmas contas e valores. As alterações feitas por qualquer um dos dois ficam visíveis para ambos em tempo real.'
      },
      {
        pergunta: 'Como ativar o compartilhamento?',
        resposta: 'Acesse "Administração" no menu lateral. No card do usuário desejado, marque a opção "Compartilhar conta com outro usuário", selecione o usuário com quem deseja compartilhar e clique em "Salvar compartilhamento".'
      },
      {
        pergunta: 'Se eu não compartilhar, o outro usuário vê meus dados?',
        resposta: 'Não. Sem compartilhamento, cada usuário tem seu próprio dashboard completamente isolado. Seus gastos, contas e tipos de conta são visíveis apenas para você.'
      },
      {
        pergunta: 'Posso desfazer o compartilhamento?',
        resposta: 'Sim. Em "Administração", desmarque a opção "Compartilhar conta com outro usuário" do usuário e salve. O compartilhamento é encerrado imediatamente — cada usuário volta a ver apenas seus próprios dados.'
      },
    ]
  },
  {
    id: 'atividades',
    icon: '📋',
    titulo: 'Registro de Atividades',
    cor: 'var(--accent)',
    topicos: [
      {
        pergunta: 'O que é o Registro de Atividades?',
        resposta: 'É um histórico que registra automaticamente as ações realizadas no sistema: criação e exclusão de contas, alteração de valores, criação de tipos e mudanças no limite mensal. Ideal para usuários que compartilham contas e precisam acompanhar o que o outro fez.'
      },
      {
        pergunta: 'Por quanto tempo as atividades ficam guardadas?',
        resposta: 'O sistema mantém o histórico dos últimos 6 meses. Registros mais antigos são removidos automaticamente toda vez que o Dashboard é carregado. Isso mantém o sistema leve e focado nas informações relevantes.'
      },
      {
        pergunta: 'Posso filtrar as atividades?',
        resposta: 'Sim! Use os filtros no topo da página: Todos, Valores, Contas, Tipos e Limites. O botão "↻ Atualizar" recarrega a lista com as atividades mais recentes.'
      },
    ]
  },
  {
    id: 'graficos',
    icon: '⟁',
    titulo: 'Gráficos',
    cor: '#4f8ef7',
    topicos: [
      {
        pergunta: 'Como acessar os gráficos?',
        resposta: 'No Dashboard, clique no botão "⟁ Gráfico" ao lado de "⊞ Tabela" no canto superior direito. Os gráficos mostram a evolução anual dos seus gastos.'
      },
      {
        pergunta: 'O que cada gráfico mostra?',
        resposta: 'Evolução Mensal: barras ou linhas com os gastos por categoria (Cartão, Fixos, Outros) mês a mês. Total vs. Limite: comparativo entre o total gasto e o limite mensal definido. Top Contas do Ano: as contas com maior gasto acumulado no ano. Resumo Anual: grid com todos os meses mostrando o total e a diferença do limite.'
      },
      {
        pergunta: 'Como alternar entre barras e linha?',
        resposta: 'Use os botões "▐▌ Barras" e "⟁ Linha" no canto superior direito da seção de gráficos para alternar o tipo de visualização.'
      },
    ]
  },
  {
    id: 'usuarios',
    icon: '⚙',
    titulo: 'Administração de Usuários',
    cor: 'var(--warn)',
    topicos: [
      {
        pergunta: 'Quem pode acessar a Administração?',
        resposta: 'Apenas usuários com perfil "Admin" têm acesso ao painel de Administração. Usuários comuns não veem este menu.'
      },
      {
        pergunta: 'Como criar um novo usuário?',
        resposta: 'Em "Administração", clique em "+ Novo Usuário". Preencha o nome completo, nome de usuário (sem espaços), senha e perfil (Admin ou Usuário). O novo usuário receberá uma senha temporária e será solicitado a trocá-la no primeiro acesso.'
      },
      {
        pergunta: 'Qual o limite de usuários por grupo?',
        resposta: 'No plano atual, cada grupo pode ter até 3 usuários. Se precisar de mais, crie uma nova conta de grupo. Futuramente haverá planos com limites maiores.'
      },
      {
        pergunta: 'Como redefinir a senha de um usuário?',
        resposta: 'Em "Administração", no card do usuário, clique em "🔑 Redefinir Senha". O sistema gera uma senha temporária aleatória que aparece na tela — anote e passe para o usuário. Ele pode trocar depois pelo link "Esqueci minha senha" na tela de login.'
      },
      {
        pergunta: 'Como tornar um usuário administrador?',
        resposta: 'Em "Administração", no card do usuário, clique em "Tornar Admin". Para rebaixar um admin a usuário comum, clique em "Tornar Usuário". Você não pode alterar seu próprio cargo.'
      },
    ]
  },
  {
    id: 'conta',
    icon: '₿',
    titulo: 'Minha Conta',
    cor: 'var(--accent)',
    topicos: [
      {
        pergunta: 'Como criar uma nova conta no Fincasa?',
        resposta: 'Na tela de login, clique em "Criar minha conta". Informe o nome do grupo (ex: Família Silva), seu nome completo, um nome de usuário (sem espaços) e uma senha. Um novo grupo isolado será criado para você.'
      },
      {
        pergunta: 'Como trocar minha senha?',
        resposta: 'Na tela de login, clique em "Esqueci minha senha". Informe seu nome de usuário — se existir no sistema, aparecerão os campos para digitar a nova senha. Confirme e salve. Você será redirecionado para o login.'
      },
      {
        pergunta: 'Como alternar entre tema escuro e claro?',
        resposta: 'Clique no botão ☀️ ou 🌙 no canto superior direito da tela. A preferência é salva automaticamente no navegador.'
      },
      {
        pergunta: 'Como recolher o menu lateral?',
        resposta: 'Clique no botão ◀ no cabeçalho do menu lateral para recolhê-lo. Os ícones continuam visíveis. Clique em ▶ para expandir novamente. Em celular, use o ☰ para abrir o menu.'
      },
    ]
  },
];

export default function AjudaPage() {
  const [aberto, setAberto] = useState({});
  const [secaoAberta, setSecaoAberta] = useState('dashboard');

  function toggleTopico(id) {
    setAberto(p => ({ ...p, [id]: !p[id] }));
  }

  const secao = SECOES.find(s => s.id === secaoAberta);

  return (
    <div className="ajuda-page fade-in">
      <div className="ajuda-header">
        <div>
          <h2 className="ajuda-title">Central de Ajuda</h2>
          <p className="text-muted text-sm">Tudo que você precisa saber para usar o Fincasa</p>
        </div>
      </div>

      <div className="ajuda-layout">
        {/* Menu lateral */}
        <div className="ajuda-nav">
          {SECOES.map(s => (
            <button
              key={s.id}
              className={`ajuda-nav-item ${secaoAberta === s.id ? 'active' : ''}`}
              onClick={() => { setSecaoAberta(s.id); setAberto({}); }}
              style={{ '--secao-cor': s.cor }}
            >
              <span className="ajuda-nav-icon">{s.icon}</span>
              <span>{s.titulo}</span>
            </button>
          ))}
        </div>

        {/* Conteúdo */}
        <div className="ajuda-conteudo">
          <div className="ajuda-secao-header" style={{ borderColor: secao.cor }}>
            <span className="ajuda-secao-icon">{secao.icon}</span>
            <h3 className="ajuda-secao-titulo">{secao.titulo}</h3>
          </div>

          <div className="ajuda-topicos">
            {secao.topicos.map((t, i) => {
              const id = `${secaoAberta}-${i}`;
              const isOpen = aberto[id];
              return (
                <div key={id} className={`ajuda-topico ${isOpen ? 'open' : ''}`}>
                  <button className="ajuda-pergunta" onClick={() => toggleTopico(id)}>
                    <span>{t.pergunta}</span>
                    <span className="ajuda-toggle">{isOpen ? '▴' : '▾'}</span>
                  </button>
                  {isOpen && (
                    <div className="ajuda-resposta">
                      {t.resposta}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
